$(document).ready(function () {
  const debug = true;
  const log = (() => {
    const colors = {
      info: "#3498db",
      success: "#2ecc71",
      error: "#e74c3c",
    };

    const logFn = (type, ...args) => {
      if (debug) {
        console.log(
          `%cNP-LPFocuspatchPet`,
          `background: ${colors[type]}; color: white; padding: 2px 5px; border-radius: 3px;`,
          ...args
        );
      }
    };

    return {
      info: (...args) => logFn("info", ...args),
      success: (...args) => logFn("success", ...args),
      error: (...args) => logFn("error", ...args),
    };
  })();

  function initScrolling() {
    $(".lp-fpp--learn-more-btn").click(function () {
      $(".lp-fpp--scroll-to-learn").fadeIn("slow");

      const sectionHeight = $(
        ".lp-fpp--why-kids-love-np-section"
      ).outerHeight();
      const sectionOffsetTop = $(".lp-fpp--why-kids-love-np-section").offset()
        .top;

      $(window).scroll(function () {
        let scrollTopj = $(window).scrollTop();
        let scrollPoint = sectionOffsetTop + sectionHeight;
        if (scrollTopj >= scrollPoint) {
          $(".lp-fpp--scroll-to-learn").fadeOut("fast");
        }
      });
    });

    log.success("Scrolling initialized");
  }

  function initTooltips() {
    $(".bundle-save-tooltip-box").on("click", function () {
      $(".bundle-save-tooltip-box").tooltip("show");
      setTimeout(() => {
        log.info("Updating tooltip");
        $(".bundle-save-tooltip-box").tooltip("update");
      }, 50);
    });
    $(".bundle-save-tooltip-box").on("show.bs.tooltip", function () {
      $(this).tooltip("update");
      $("#blur").fadeIn();
      log.info("Tooltip shown");
    });
    $(".bundle-save-tooltip-box").on("hide.bs.tooltip", function () {
      $("#blur").fadeOut();
      log.info("Tooltip hidden");
    });

    $("#blur").on("click", function (e) {
      $(".bundle-save-tooltip-box").tooltip("hide");
    });

    $('[data-toggle="tooltip"]').tooltip({
      container: ".form-group",
      boundary: ".form-group",
      animated: true,
      placement: "top",
      trigger: "manual",
      delay: { show: 100, hide: 100 },
    });
    log.success("Tooltips initialized");
  }

  function initFormBindings() {
    log.info("initFormBindings()");

    const priceNumEl = $(".overall-price .price-num");
    const priceOffEl = $(".overall-price .price-off, .pet-zenp--b-s-pack-percent-off .price-off");
    const priceCompareEl = $(".compare-price");
    const priceSavedEl = $(".saved-price");
    const petLocket = $('#petlocket');

    function isPetLocketChecked() {
      return petLocket.is(":checked");
    }

    function updateTotals() {
      log.info('updateTotals()');
      const totals = window.LPProductForm.getTotal();
      const formatted = totals.formatted;
      priceNumEl.text(formatted.price);
      priceOffEl.text(formatted.percentageOff);
      priceCompareEl.text(formatted.compareAtPrice);
      priceSavedEl.text(formatted.saved);

      if (formatted.hasSubscriptions === true) {
        log.info('hasSubscriptions');
        const subscriptionPrice = formatted?.subscriptionPrice;
        log.info('subscriptionPrice');
        $('.loc_gated_selling_plan__subscription_info').removeClass('hidden');
        $('.subscription-price').text(subscriptionPrice);
      } else {
        $('.loc_gated_selling_plan__subscription_info').addClass('hidden');
      }
    }

    function updatePackPrices() {
      log.info("updatePackPrices()");
      const packs = $('.packs input[type="radio"]');
      packs.each(function () {
        const packInp = $(this);
        const pack = packInp.closest(".packs");
        const packQty = packInp.val();
        let packPrice = parseFloat(packInp.attr("data-price").replace(/[^\d.-]/g, '')) * 100 / packQty;
        let packCompareAtPrice = parseFloat(packInp.attr("data-compare-at-price").replace(/[^\d.-]/g, '')) * 100 / packQty;
        const packSellingPlanId = packInp.attr("data-selling-plan-id");
        
        if (packSellingPlanId > 0) {
          log.info(`Using subscription ID: ${packSellingPlanId}`);
          const packSellingPlanPercentOff = packInp.attr("data-subscription-percent-off");
          log.info(`Using subscription percent off: ${packSellingPlanPercentOff}`);
          packPrice = packPrice * (1 - packSellingPlanPercentOff / 100);
          log.info(`New pack price: ${packPrice}`);
          packCompareAtPrice = packCompareAtPrice * (1 - packSellingPlanPercentOff / 100);

          pack.find(".lp-fpp--pack-price").text(`${Shopify.formatMoney(packPrice)} Each`); 
        }
      });
    }

    window.addEventListener("locGateSubsAdded", (event) => {
      updatePackPrices();
    });
    if (window.locGated === true) {
      updatePackPrices();
    }

    function updateForm() {
      const selectedRadio = $('.packs input[type="radio"]:checked');
      if (selectedRadio.length) {
        const currentId = selectedRadio.attr("data-tick-id");
        const currentName = selectedRadio.attr("data-name");
        const price = parseFloat(selectedRadio.attr("data-price").replace(/[^\d.-]/g, '')) * 100;
        const compareAtPrice = parseFloat(selectedRadio.attr("data-compare-at-price").replace(/[^\d.-]/g, '')) * 100;
        const sellingPlanId = selectedRadio.attr("data-selling-plan-id");
        const sellingPlanPercentOff = selectedRadio.attr("data-subscription-percent-off");
        log.info(`updateForm() - Option selected: ${currentName}`);

        window.LPProductForm.setSKUs([
          {
            sku: currentId,
            quantity: 1,
            name: currentName,
            price: price,
            compareAtPrice: compareAtPrice,
            sellingPlanId: sellingPlanId,
            sellingPlanPercentOff: sellingPlanPercentOff,
          },
        ]);

        // Disable the pet locket if the user selects the bundle that already has it
        if (selectedRadio.val() === "5") {
          petLocket.prop("disabled", true);
          petLocket.prop("checked", false);
        } else {
          petLocket.prop("disabled", false);
        }
      }

      if (isPetLocketChecked()) {
        window.LPProductForm.addSKU({
          sku: petLocket.val(),
          quantity: 1,
          name: "Pet Locket",
          price: petLocket.attr("data-price"),
          compareAtPrice: petLocket.attr("data-compare-at-price"),
          sellingPlanId: petLocket.attr("data-selling-plan-id"),
          sellingPlanPercentOff: petLocket.attr("data-subscription-percent-off"),
        });
      }

      updateTotals()
    }

    updateForm();
    $('.packs input[type="radio"]').change(updateForm);

    const PRIMARY_COLOR = "#D04119";
    $("#petlocket").on("change", function () {
      updateForm();
      if ($(this).is(":checked")) {
        $(this)
          .closest(".purchase__pet-locket")
          .css("border", `2px solid ${PRIMARY_COLOR}`);
        log.info("Pet locket checked");
      } else {
        $(this)
          .closest(".purchase__pet-locket")
          .css("border", "2px solid #F0F0F4");
        log.info("Pet locket unchecked");
      }
    });

    $("#proceed").click(async function (event) {
      event.preventDefault();
      log.info("Form submission intercepted");
      await window.LPProductForm.submitCart();
    });

    log.success("initFormBindings() - Form initialization complete");
  }

  // Check if LPProductForm is available and initialized
  if (window.LPProductForm?.isInitialized) {
    initFormBindings();
  } else {
    // If not immediately available, wait for it
    var checkInterval = setInterval(function () {
      if (window.LPProductForm?.isInitialized) {
        clearInterval(checkInterval);
        initFormBindings();
      }
    }, 100);
  }

  initTooltips();
  initScrolling();
});
